/* @format */
import store from '@/stores';
import { api } from '@/scripts/api';
import { limitErrors } from './woli-errors';
import EventBus from '@/scripts/event-bus';
import { WOLI_POPUP_TYPE } from '@/components/popups/woli/woli-popup-store';

export const WOLI_OPEN_EVENT = 'woli:open';
export const WOLI_CLOSE_EVENT = 'woli:close';
export const WOLI_CLOSED_EVENT = 'woli:closed';
export const WOLI_INSERT_TEXT_EVENT = 'woli:insert-text';

const WOLI_CONVERSATIONS_ENDPOINT = '/ms/woli/v1/conversations';
const WOLI_REWRITE_ENDPOINT = `/ms/woli/v1/rewrite`;

export const WoliService = {
    openWoliPopup(config = {}) {
        config = {
            context: {},
            popupType: WOLI_POPUP_TYPE.DEFAULT,
            defaultInput: '',
            ...(config ?? {}),
        };

        EventBus.$emit(WOLI_OPEN_EVENT, config);
    },

    closeWoliPopup() {
        EventBus.$emit(WOLI_CLOSE_EVENT);
    },

    async getConversations() {
        return await api.get(WOLI_CONVERSATIONS_ENDPOINT);
    },

    async getConversation(conversationId, signal) {
        return await api.get(`${WOLI_CONVERSATIONS_ENDPOINT}/${conversationId}`, signal);
    },

    async createConversation(prompt, contextType, variables, accountId) {
        const isOrgUser = store.getters.isOrganizationUser;
        const service = isOrgUser
            ? `${WOLI_CONVERSATIONS_ENDPOINT}/org`
            : `${WOLI_CONVERSATIONS_ENDPOINT}/account/${accountId}`;

        if (!isOrgUser && !accountId) {
            throw new Error('Account ID not found');
        }

        return await api.post(service, {
            content: prompt,
            context: {
                contextType,
                variables,
            },
        });
    },

    async promptConversation(conversationId, content, assistantResponseShown) {
        return await api.post(`${WOLI_CONVERSATIONS_ENDPOINT}/${conversationId}/prompt`, {
            content,
            assistantResponseShown,
        });
    },

    async updateAssistantResponseShown(conversationId, assistantResponseShown) {
        return await api.put(
            `${WOLI_CONVERSATIONS_ENDPOINT}/${conversationId}/assistantResponseShown`,
            {
                assistantResponseShown,
            },
        );
    },

    async generateConversationName(conversationId) {
        return await api.post(`${WOLI_CONVERSATIONS_ENDPOINT}/${conversationId}/name/generate`);
    },

    renameConversation(conversationId, name) {
        return api.put(`${WOLI_CONVERSATIONS_ENDPOINT}/${conversationId}/name/rename`, {
            name,
        });
    },

    async regenerateResponse(conversationId, assistantResponseShown) {
        return await api.post(`${WOLI_CONVERSATIONS_ENDPOINT}/${conversationId}/regenerate`, {
            assistantResponseShown,
        });
    },

    async deleteConversation(conversationId) {
        return await api.delete(`${WOLI_CONVERSATIONS_ENDPOINT}/${conversationId}`);
    },

    async deleteAllConversations() {
        return await api.delete(WOLI_CONVERSATIONS_ENDPOINT);
    },

    async generateRewrite(content, action, tone) {
        const isOrgUser = store.getters.isOrganizationUser;
        const accountId = store.state.context.account.id;

        if (!isOrgUser && !accountId) {
            throw new Error('Account ID not found');
        }

        const endpoint = isOrgUser
            ? `${WOLI_REWRITE_ENDPOINT}/org`
            : `${WOLI_REWRITE_ENDPOINT}/account/${accountId}`;

        const body = {
            content,
            action,
        };

        if (tone) {
            body.tone = tone;
        }

        return await api.post(endpoint, body);
    },

    getLimitErrorMessage(errorCode) {
        return limitErrors[errorCode] || 'An error occurred. Please try again later.';
    },
};
